import { render, staticRenderFns } from "./firma.vue?vue&type=template&id=0efb461a&scoped=true&"
import script from "./firma.vue?vue&type=script&lang=js&"
export * from "./firma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efb461a",
  null
  
)

export default component.exports